import React from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { SERVICES } from "../data/mockData";
import Icon from "../components/common/Icon";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const Services = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      
      <div className="bg-slate-900 text-white pt-36 pb-20 relative">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1496247749665-49cf5b1022e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1Mjh8MHwxfHNlYXJjaHwxfHxpbmR1c3RyaWFsJTIwZmFjdG9yeXxlbnwwfHx8fDE3NzA0Mzg1MTB8MA&ixlib=rb-4.1.0&q=85')] bg-cover bg-center opacity-20"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h1 className="text-5xl font-display font-bold uppercase tracking-wide mb-4">Our Services</h1>
          <p className="text-xl text-gray-300 max-w-2xl font-light">
            Comprehensive solutions for the entire asset lifecycle.
          </p>
        </div>
      </div>

      <main className="flex-grow py-20 bg-gray-50">
        <div className="container mx-auto px-4 space-y-24">
          {SERVICES.map((service, idx) => (
            <div key={service.id} className={`flex flex-col ${idx % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}>
              {/* Image Side */}
              <div className="w-full lg:w-1/2">
                <div className="relative group overflow-hidden shadow-2xl">
                   <div className="absolute inset-0 bg-primary/20 group-hover:bg-primary/0 transition-colors z-10"></div>
                   <img 
                    src={service.image} 
                    alt={service.title} 
                    className="w-full h-[400px] object-cover transition-transform duration-700 group-hover:scale-105"
                   />
                </div>
              </div>

              {/* Content Side */}
              <div className="w-full lg:w-1/2 space-y-6">
                <div className="flex items-center gap-3 mb-2">
                   <div className="p-3 bg-primary/10 rounded-sm text-primary">
                      <Icon name={service.icon} size={32} />
                   </div>
                   <h2 className="text-3xl font-display font-bold text-foreground">{service.title}</h2>
                </div>
                
                <p className="text-gray-600 text-lg leading-relaxed">
                  {service.description}
                </p>

                <div className="bg-white p-6 border border-gray-100 shadow-sm">
                  <h4 className="font-bold text-primary uppercase tracking-wider text-sm mb-4">Key Capabilities</h4>
                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    {service.features.map((feature, fIdx) => (
                      <li key={fIdx} className="flex items-center gap-2 text-gray-700 text-sm">
                        <span className="h-1.5 w-1.5 bg-secondary rounded-full"></span>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="pt-4">
                  <Button className="bg-primary text-white rounded-none px-8 uppercase tracking-widest" asChild>
                    <Link to="/contact">Enquire Now</Link>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Services;
